/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elastic_Gallery_Item_05_TitleInputs */

const en_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Future Tech`)
};

const ar_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقنية المستقبل`)
};

const bn_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভবিষ্যৎ টেক`)
};

const de_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zukunftstechnologie`)
};

const es_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnología futura`)
};

const fr_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologie future`)
};

const pt_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologia do futuro`)
};

const zh_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未来科技`)
};

const tr_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geleceğin Teknolojisi`)
};

const ru_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технологии будущего`)
};

const pl_elastic_gallery_item_05_title = /** @type {(inputs: Elastic_Gallery_Item_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologia przyszłości`)
};

/**
* | output |
* | --- |
* | "Future Tech" |
*
* @param {Elastic_Gallery_Item_05_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const elastic_gallery_item_05_title = /** @type {((inputs?: Elastic_Gallery_Item_05_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elastic_Gallery_Item_05_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_elastic_gallery_item_05_title(inputs)
	if (locale === "bn") return bn_elastic_gallery_item_05_title(inputs)
	if (locale === "de") return de_elastic_gallery_item_05_title(inputs)
	if (locale === "es") return es_elastic_gallery_item_05_title(inputs)
	if (locale === "fr") return fr_elastic_gallery_item_05_title(inputs)
	if (locale === "pt") return pt_elastic_gallery_item_05_title(inputs)
	if (locale === "zh") return zh_elastic_gallery_item_05_title(inputs)
	if (locale === "tr") return tr_elastic_gallery_item_05_title(inputs)
	if (locale === "ru") return ru_elastic_gallery_item_05_title(inputs)
	if (locale === "pl") return pl_elastic_gallery_item_05_title(inputs)
	return en_elastic_gallery_item_05_title(inputs)
});